export type SyncStatus =
  | "Saved on this device"
  | "Pending sync"
  | "Syncing"
  | "Synced"
  | "Failed"
  | "Conflict";

export type PhotoVerificationStatus =
  | "pending"
  | "uploaded"
  | "verified"
  | "failed";

export type UserRole = "driver" | "member" | "admin";

export interface VehicleDto {
  id: string;
  label: string;
  registration: string;
}

export interface WorkingDayDto {
  id: string;
  vehicleId: string;
  startedAt: string;
  endedAt: string | null;
  status: "active" | "ended";
  clientUpdatedAt: string;
}

export interface JobDto {
  id: string;
  workingDayId: string;
  title: string;
  notes: string;
  createdAt: string;
  clientUpdatedAt: string;
}

export interface EventDto {
  id: string;
  workingDayId: string;
  jobId: string | null;
  eventType: string;
  occurredAt: string;
  notes: string;
  clientUpdatedAt: string;
}

export interface PhotoMetaDto {
  id: string;
  workingDayId: string;
  jobId: string | null;
  eventId: string | null;
  filename: string;
  contentType: string;
  byteSize: number;
  sha256: string;
  verificationStatus: PhotoVerificationStatus;
  capturedAt: string;
  clientUpdatedAt: string;
}

export interface SyncPayload {
  workingDays: WorkingDayDto[];
  jobs: JobDto[];
  events: EventDto[];
  photos: PhotoMetaDto[];
}

export interface SyncResult {
  workingDays: WorkingDayDto[];
  jobs: JobDto[];
  events: EventDto[];
  photos: PhotoMetaDto[];
  conflicts: string[];
}

export interface SessionUser {
  id: string;
  organisationId: string;
  email: string;
  displayName: string;
  role: UserRole;
  disclaimerAccepted: boolean;
}

export interface BuildInfo {
  applicationEnvironment: string;
  commitSha: string;
  commitRef: string;
  deploymentProvider: string;
  host: string;
  frozenCandidate: boolean;
}

export const DISCLAIMER_VERSION = "2026-10-13";
export const DISCLAIMER_TEXT =
  "LogProof stores operational records on this device and syncs a server copy for your organisation. Browser storage is per browser — clearing site data removes local records. This is not an Electronic Work Diary and is not regulator-ready. Synthetic data only. No GPS.";
